import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { Shield, ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { authAPI } from '../services/api';

export default function ForgotPassword() {
  const { t } = useTranslation('auth');
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault(); setLoading(true); setError('');
    try { await authAPI.forgotPassword(email.trim()); setSubmitted(true); }
    catch { setError(t('forgot.error.submitFailed')); }
    finally { setLoading(false); }
  };

  return <div className="min-h-full bg-[var(--v-base-bg)] flex items-center justify-center p-4"><div className="w-full max-w-md">
    <Link to="/login" className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-8"><ArrowLeft className="w-4 h-4" />{t('shared.backToLogin')}</Link>
    <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8">
      <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mx-auto mb-6"><Shield className="w-8 h-8 text-blue-600" /></div>
      <h1 className="text-2xl font-bold text-slate-900 text-center mb-2">{t('forgot.title')}</h1>
      <p className="text-slate-500 text-center mb-8">{submitted ? t('forgot.submittedBody') : t('forgot.body')}</p>
      {submitted ? <Link to="/login" className="block w-full text-center min-h-11 py-3 px-4 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700">{t('forgot.backToLoginCta')}</Link> : <form className="space-y-4" onSubmit={handleSubmit}>
        <label className="block text-sm font-medium text-gray-700">{t('auth.email')}<input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t('auth.emailPlaceholder')} className="w-full mt-2 min-h-11 px-4 py-3 border-2 border-gray-200 rounded-xl text-gray-900" /></label>
        {error && <p className="text-sm text-red-600" role="alert">{error}</p>}
        <button type="submit" disabled={loading} className="w-full min-h-11 py-3 px-4 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 disabled:opacity-50">{loading ? t('shared.sending') : t('forgot.sendLink')}</button>
      </form>}
      <p className="text-sm text-slate-500 text-center mt-6">{t('forgot.rememberPassword')} <Link to="/login" className="text-blue-600 font-medium hover:underline">{t('shared.loginLink')}</Link></p>
    </div>
  </div></div>;
}
